import React from 'react'
import { AdminAppbar } from '../../modules/admin/components/navbar/main'
import { AdminFeatureNavbar } from '../../modules/admin/components/navbar/navbar'
import { BaseLayout } from './base-layout'

/**
 * Layout for admins funtionality
 */
export function AdminsLayout({ children }: { children: JSX.Element | JSX.Element[] }): JSX.Element {
  return (
    <BaseLayout appbar={<AdminAppbar />} additionalContent={<AdminFeatureNavbar />}>
      {children}
    </BaseLayout>
  )
}
